import { render, staticRenderFns } from "./UserInfoBasic.vue?vue&type=template&id=7f8411d9&scoped=true&"
import script from "./UserInfoBasic.vue?vue&type=script&lang=js&"
export * from "./UserInfoBasic.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoBasic.vue?vue&type=style&index=0&id=7f8411d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8411d9",
  null
  
)

export default component.exports